module.exports = __webpack_public_path__ + "static/mimi-guarneri-headshot.bf3ab9db.jpg";